/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  PaymentCardsUserControllerDeleteMutationResponse,
  PaymentCardsUserControllerDeletePathParams,
  PaymentCardsUserControllerDelete400,
  PaymentCardsUserControllerDelete401,
  PaymentCardsUserControllerDelete404,
} from '../types/PaymentCardsUserControllerDelete.ts';

function getPaymentCardsUserDeleteUrl(
  paymentSystem: PaymentCardsUserControllerDeletePathParams['paymentSystem'],
  id: PaymentCardsUserControllerDeletePathParams['id'],
) {
  const res = { method: 'DELETE', url: `/api/user/payment-cards/${paymentSystem}/${id}` as const };
  return res;
}

/**
 * @summary Unlink own saved card and disable auto renewal for its linked subscriptions
 * {@link /api/user/payment-cards/:paymentSystem/:id}
 */
export async function paymentCardsUserDelete(
  paymentSystem: PaymentCardsUserControllerDeletePathParams['paymentSystem'],
  id: PaymentCardsUserControllerDeletePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PaymentCardsUserControllerDeleteMutationResponse,
    ResponseErrorConfig<
      PaymentCardsUserControllerDelete400 | PaymentCardsUserControllerDelete401 | PaymentCardsUserControllerDelete404
    >,
    unknown
  >({ method: 'DELETE', url: getPaymentCardsUserDeleteUrl(paymentSystem, id).url.toString(), ...requestConfig });
  return res.data;
}
